/**
 * The lifecycle status of a service provider's profile, as stored in `service_providers.status`.
 *
 * @see \Api\Model\Table\ProvidersTable
 */
export enum ProfileStatus {
    DISABLED = 0,
    ENABLED = 1,
    /** Imported but never edited by the provider or by us. */
    UNTOUCHED = 2,
    ON_HOLD = 3,
    /** Removed at the provider's request; the row is kept for bookkeeping only. */
    GDPR = 4,
    DISABLED_BAD_PROFILE = 5,
    /** Placeholder profile that is never shown on the platform. */
    GHOST = 6,
    NEW_IMPORT = 7,
    CHURNED = 8,
}
